import type { FeatureFlag } from './utils/featureFlags/types';

export const inspiringSearchPrototype: FeatureFlag = {
  name: 'inspiringSearchPrototype',
  isPartOfTestGroup: () => false, // NOTE will be properly implemented once an A/B test is scheduled, and set to `true` for the protolab feature branch
};

export const newInfiniteScrolling: FeatureFlag = {
  name: 'newInfiniteScrolling',
  isPartOfTestGroup: () => false, // NOTE will be properly implemented once an A/B test is scheduled, and set to `true` for the protolab feature branch
};
